<template>
  <section class="about">
    <div class="heading">
      <div class="heading-container">
        <h3>about us</h3>
        <p>
          <router-link :to="{ name: 'Home' }" class="home text-decoration-none"
            >home</router-link
          >
          / <span>about</span>
        </p>
      </div>
    </div>
    <div class="about-container">
      <div class="image">
        <img :src="about" alt="" />
      </div>
      <div class="content">
        <span>welcome to our shop</span>
        <h3>we make your home more astonishing</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ullam
          officiis, reiciendis veniam incidunt architecto quam velit dolorum
          exercitationem cum aliquam ab quas dicta dolores ad earum quasis.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente
          adipisci totam, nam voluptates quis delectus. Ea quo repudiandae.
        </p>
        <router-link to="#" class="btn">read more</router-link>
      </div>
    </div>
    <Service />
  </section>
</template>

<script>
import Service from "./../components/Service";
export default {
  data() {
    return {
      about: require("@/images/about-img.jpg"),
    };
  },
  components: {
    Service,
  },
};
</script>